import(/* webpackMode: "eager" */ "/vercel/path0/app/(comLayout)/politicas-de-privacidade/page.tsx");
